<script setup lang="ts">
    import { useAdjustmentsMeasurementsViewModel } from '@/views/3d-planner/measurements/useAdjustmentsMeasurementsViewModel';
    import AdjustmentMeasurement from '@/views/3d-planner/measurements/components/AdjustmentMeasurement.vue';
    import NativeMeasurement from '@/views/3d-planner/measurements/components/NativeMeasurement.vue';
    import ResectionHeight from '@/views/3d-planner/measurements/components/ResectionHeight.vue';
    import { nativeMeasurementTarget } from '@/domain/analytics/analyticsTargets';

    const vm = useAdjustmentsMeasurementsViewModel();
</script>

<template>
    <div class="adjustments">
        <div class="title">Adjustments</div>
        <div v-for="(adjustment, key) in vm.adjustments" :key="`${key}`" class="group">
            <AdjustmentMeasurement :id="key" :adjustment="adjustment" />
        </div>
    </div>
    <div class="measurements" data-testid="native-measurements">
        <div class="title">Native Measurements</div>
        <div v-for="(measurement, key) in vm.nativeMeasurements" :key="`${key}`" class="group">
            <NativeMeasurement
                :id="key"
                :measurement="measurement"
                :data-analytics-id="nativeMeasurementTarget(key)"
            />
        </div>
    </div>
    <ResectionHeight />
</template>

<style scoped lang="scss">
    .title {
        font-size: 0.75rem;
        font-weight: 500;
        letter-spacing: 0.1666666667em;
        line-height: 2rem;
        text-transform: uppercase;
        color: rgb(var(--v-theme-white));
        width: 100%;
    }

    .adjustments,
    .measurements {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 40px;
    }

    .measurements {
        .group {
            flex-basis: 50%;
        }
    }

    .group {
        display: flex;
        flex-direction: column;
        flex-basis: 33%;
        margin-bottom: 10px;
    }

    .group-value {
        font-weight: 700;
        font-size: 1rem;
        letter-spacing: 0.009375em;
        line-height: 1.75rem;
        color: rgb(var(--v-theme-white));
    }

    .group-label {
        font-size: 0.75rem;
        letter-spacing: 0.0333333333em;
        line-height: 1.25rem;
        color: rgb(var(--v-theme-on-scene-background));
    }
</style>
